<template>
  <div class="paid">
    <div class="paid-header">
      <div class="paid-header-dw">
        <div class="paid-header-tit">付费资讯中心</div>
        <div class="paid-header-search">
          <input type="text" placeholder="请输入搜索内容">
          <button>搜索</button>
        </div>
      </div>
    </div>
    <div class="paid-center">
      <div>
        <h4>付费资讯</h4>
      </div>
      <div class="paid-center-right">
        <ul>
          <li>
            <router-link to="/paid-information-title?id=0">【付费资讯】下沉市场不需要巨头，但很需要社区团购<span class="red">（收费：1元/次）</span></router-link>
          </li>
          <li>
            <router-link to="/paid-information-title?id=1">【付费资讯】中国制造网“三月采购节”启动 推出直播带货等活动<span class="red">（收费：1元/次）</span></router-link>
          </li>
          <li>
            <router-link to="/paid-information-title?id=2">【付费资讯】两会后电商新时代！透露出哪些新经济趋势？<span class="red">（收费：1元/次）</span></router-link>
          </li>
          <li>
            <router-link to="/paid-information-title?id=3">【付费资讯】2021年中国互联网发展趋势<span class="red">（收费：1元/次）</span></router-link>
          </li>
          <li>
            <router-link to="/paid-information-title?id=4">【付费资讯】2021年互联网行业展望：全面拥抱数字时代<span class="red">（收费：1元/次）</span></router-link>
          </li>
          <li>
            <router-link to="/paid-information-title?id=5">【付费资讯】5G技术能为智能制造赋能哪些？<span class="red">（收费：1元/次）</span></router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
.paid-header {
  width: 100%;
  height: 100px;
  background: url(../../assets/images/pian-background.jpg);
  background-size: 100% 100%;
}
.paid-header-dw,
.paid-center {
  margin: 0 auto;
  width: 1200px;
  display: flex;
}
.paid-header-dw div {
  flex-direction: row;
  flex-wrap: wrap;
}
.paid-header-tit {
  width: 300px;
  font-size: 30px;
  line-height: 100px;
  color: #fff;
}
.paid-header-search {
  width: 800px;
  line-height: 100px;
}
.paid-header-search input {
  height: 32px;
  width: 500px;
  border: none;
  border-radius: 20px 0 0 20px;
  padding: 6px 20px;
  font-size: 14px;
  font-weight: 100;
  color: #555;
}
.paid-header-search button {
  border: none;
  width: 100px;
  height: 44px;
  line-height: 44px;
  margin: -1px 0 0 -4px;
  border-radius: 0 20px 20px 0;
  cursor: pointer;
  background: #e4393c;
  font-size: 18px;
  font-weight: 100;
  color: #fff;
  vertical-align: middle;
}
.paid-center {
  padding: 40px 0 100px 0;
}
.paid-center div {
  flex-direction: row;
  flex-wrap: wrap;
}
.paid-center div h4 {
  display: inline-block;
  width: 200px;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  text-align: center;
  background: #333333;
  color: #fff;
}
.paid-center-right {
  width: 800px;
  padding-left: 40px;
}
.paid-center-right li {
  width: 100%;
  line-height: 50px;
  font-size: 14px;
  color: #555;
  border-bottom: 1px solid #eee;
}
.red {
  color: #f00;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// index.vue?128c7a15